import React, { Component } from "react";
import { langCheck } from "Pub/js/utils";
import WidgetJSLoader from "Pages/NewHome/CreaterForWidget/WidgetJSLoader";
import { WidgetSidePath } from "Pub/js/constant";
import platform from "Pub/js/platform";
const { NCSwitch, NCRadio } = platform.base;
const { NCRadioGroup } = NCRadio;
import { AppDataBgs, AppSettingBgs } from "Pub/js/backgroundImg";
import SelectIcon from 'Assets/images/select-icon.svg';
import "./index.less";

export default class AppSide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widgetSide: null
        }
    }

    componentDidMount() {
        WidgetJSLoader(WidgetSidePath, key => {
            const widgetSide = window[key].default;
            if (widgetSide) {
                this.setState({
                    widgetSide
                });
            }
        });
    }

    render() {
        const { onClose, onChange } = this.props;
        const { widgetSide: WidgetSide } = this.state;
        const { sideData = {} } = this.props;
        const { background = {} } = sideData;
        const BgTypeArr = [
            { label: langCheck('0000PUB-000627' /* 数据看板 */), type: 'dataBoard', data: AppDataBgs },
            { label: langCheck('0000PUB-000399' /* 业务设置 */), type: 'businessSetting', data: AppSettingBgs },
        ];
        return typeof WidgetSide === 'function'
            ?
            <WidgetSide
                maskClose={onClose}
                onClose={onClose}
                widgetProps={this.props}
                hideArea={['name', 'input', 'switch']}
            >
                <div className="common-widget-side app-side">
                    <div className="side-item">
                        <span className="item-label name">
                            {langCheck('0000PUB-000612' /* 应用背景显示 */)}
                            <NCSwitch className="switch" checked={background.show} onChange={val => {
                                const newBackground = { ...background, show: val };
                                if (!newBackground.type) {
                                    newBackground.type = 'dataBoard';
                                }
                                if (!newBackground.pictureKey) {
                                    newBackground.pictureKey = BgTypeArr[0].data[0].key;
                                }
                                onChange({ ...sideData, background: newBackground });
                            }}></NCSwitch>
                        </span>
                        {
                            background.show && <div className="item-content">
                                <NCRadioGroup
                                    className="item-bg-radios"
                                    selectedValue={background.type}
                                    name='appBackground'
                                    onChange={val => {
                                        onChange({ ...sideData, background: { ...background, type: val } });
                                    }}
                                >
                                    {
                                        BgTypeArr.map(bgItem => <div key={bgItem.type} className={`radio-content ${background.type === bgItem.type ? 'selected' : ''}`}>
                                            <NCRadio fieldid={`app-bg-${bgItem.type}`} value={bgItem.type}>{bgItem.label}</NCRadio>
                                            {
                                                background.type === bgItem.type && <div className="select-area">
                                                    {
                                                        bgItem.data.map((item, index) =>
                                                            <div key={index} className={`item-select ${item.key === background.pictureKey ? 'active' : ''}`}>
                                                                <img className='select-icon' src={SelectIcon} />
                                                                <div
                                                                    fieldid={`bg-picture-${index}`}
                                                                    style={{ backgroundImage: `url(${item.src})` }}
                                                                    className={`picture-item nc-theme-area-split-bc nc-theme-zrow-bgc`}
                                                                    onClick={() => {
                                                                        onChange({ ...sideData, background: { ...background, pictureKey: item.key } });
                                                                    }}
                                                                >
                                                                </div>
                                                            </div>,
                                                        )
                                                    }
                                                </div>
                                            }
                                        </div>)
                                    }
                                </NCRadioGroup>
                            </div>
                        }
                    </div>
                </div>
            </WidgetSide>
            :
            null
    }
}